import { jsxs as A, jsx as y } from "react/jsx-runtime";
import "../../queries/message/index.js";
import "../../queries/contact/index.js";
import { calendars as B } from "../../queries/calendars/index.js";
import { a0 as k, a1 as Z, g as V, D as z, b as Q } from "../../pointsGraph-DTJju-rA.js";
import "../../queries/student/index.js";
import "../../queries/settings/index.js";
import "../../queries/points/index.js";
import "../../queries/assessment/index.js";
import "../../queries/assessment/annotations/index.js";
import "../../queries/assessment/rubrics/index.js";
import "../../queries/assessment/qcesubjects/index.js";
import "../../queries/assessment/extensionrequest/index.js";
import "../../queries/files/index.js";
import "../../queries/attendance/index.js";
import "../../queries/forms/index.js";
import "../../queries/notifications/index.js";
import "../../queries/interviews/index.js";
import "../../queries/notes/index.js";
import "../../queries/annoucements/index.js";
import "../../queries/payments/index.js";
import { analysis as U } from "../../queries/assessment/analysis/index.js";
import "../../queries/group/index.js";
import "../../queries/projects/index.js";
import "../../queries/courses/index.js";
import "../../queries/password/index.js";
import { useState as G, useRef as Y, useEffect as J } from "react";
import { Alert as R, AlertTitle as K, Button as M, Box as X, FormControl as E, InputLabel as _, Select as j, MenuItem as W } from "@mui/material";
import F from "dayjs";
import { DatePicker as q } from "@mui/x-date-pickers";
k.register(...Z);
function ee(l) {
  u.ClearCharts();
  const a = l.body;
  a.querySelectorAll(".analysisReportData").forEach((t) => {
    const r = t.querySelector("table");
    if (!r || r.rows.length <= 1)
      return null;
    const e = r.getAttribute("data-type");
    if (e == "Combined" || r && r.rows.length > 500)
      return null;
    const o = r.rows[0], f = t.id.replace("divReport", "divGpaChart"), d = a.querySelector(`#${f} canvas`), g = t.id.replace("divReport", "divGpaRadar"), p = a.querySelector(`#${g} canvas`), i = a.querySelector(`#${f} .Legend`), s = ["Pivot", "Distribution"].includes(e) ? "bar" : "line";
    var c = u.GroupData(o);
    if (c.groupCols > 1) {
      for (var h = 1; h < r.rows.length; h++)
        r.rows[h].cells[0].getAttribute("data-group") && u.ToggleGroup(r.rows[h].cells[0]);
      for (var b = 0; b < c.groupCols - 1; b++) {
        var w = u.GroupCol(r, b, c.groupCols, c.cols);
        w.forEach((v) => {
          u.ToggleGroup(v, !0), v.addEventListener("click", function() {
            var C = this.getAttribute("toggled") == "true";
            this.setAttribute("toggled", !C), u.ToggleGroup(this, C, 30);
            const T = a.querySelectorAll('td[toggled="true"]').length > 0 && !C ? this : null, x = a.querySelector(`#${f}`).querySelector(".divChartTitle");
            setTimeout(() => {
              var L = u.InitCharts(r, c, f, d, s, g, p, i, T);
              x && (x.innerHTML = L);
            }, 500);
            var m = this.getAttribute("data-caption"), I = this.getAttribute("data-groupRow");
            C ? this.innerHTML = "> " + m + " (" + I + " rows) " : this.innerHTML = "- " + m + " (" + I + " rows) ";
          });
        });
      }
    }
    u.InitCharts(r, c, f, d, s, g, p, i);
  });
}
const u = {
  Charts: {},
  Colors: ["#aab2f2", "#aaf2e5", "#f2d2aa", "#f2f0aa", "#aaf2ed", "#b6f2aa", "#f2afaa", "#f2e1aa", "#aaf2d7", "#f2b3aa", "#aaddf2", "#d1aaf2", "#aaf2ad", "#f2bcaa", "#f2baaa", "#f2beaa", "#aabdf2", "#aaf2c5", "#f2c4aa", "#c5aaf2", "#aaaef2", "#baaaf2", "#aaf2c2", "#eff2aa", "#c4aaf2", "#aaeff2", "#d8f2aa", "#f2aaae", "#f2aac3", "#b5f2aa", "#aaf2cf", "#dff2aa", "#f2c9aa", "#e2aaf2", "#f2aab4", "#f2d4aa", "#aab3f2", "#aaf2e3", "#e3f2aa", "#e8f2aa", "#aaf2e7", "#def2aa", "#aac8f2", "#f2aac0", "#c9aaf2", "#f2d1aa", "#f2aaab", "#f2aad7", "#acaaf2", "#c9f2aa", "#f2b0aa", "#d8aaf2", "#f2dfaa", "#f2aab9", "#aae4f2", "#edf2aa", "#b9aaf2", "#ebaaf2", "#c5f2aa", "#aaf0f2", "#f2aac1", "#d3f2aa", "#d0aaf2", "#aaf2eb", "#e9f2aa", "#aaf2d2", "#c0aaf2", "#d3aaf2", "#aab8f2", "#aac7f2", "#aaf2d4", "#bff2aa", "#f2aacd", "#aacaf2", "#f2bbaa", "#c3aaf2", "#f2aad6", "#aaf2b8", "#f2eeaa", "#d2f2aa", "#aaf2c9", "#f2aad4", "#aaf2b9", "#bbf2aa", "#f2aabd"],
  BuildChart: (l, a, t, r, e, n, o = null) => {
    u.Charts[t] && u.Charts[t].destroy(), u.Charts[t] = new k(r, {
      type: n,
      data: {
        labels: a,
        datasets: l
      },
      options: o ?? {
        responsive: !1,
        plugins: { legend: { display: !1 } },
        scales: {
          y: isNaN(e) ? {} : {
            type: "linear",
            display: !0,
            position: "left",
            max: e,
            min: 0
          }
        }
      }
    });
  },
  Calc: {
    Average: (l, a) => {
      for (var t = a.length, r = 0, e = 0; e < a.length; e++)
        a[e], r += u.Calc.ParseOrZero(a[e].cells[l]);
      return t > 0 ? (r / t).toFixed(2) : "";
    },
    Distribution: (l, a, t) => {
      for (var r = 0, e = 0; e < a.length; e++)
        a[e], r += u.Calc.ParseOrZero(a[e].cells[l + 1]);
      return t > 0 ? (100 * r / t).toFixed(0) : "";
    },
    ParseOrNull: (l) => {
      var a;
      return l.getAttribute("data-val") ? a = parseFloat(l.getAttribute("data-val")) : a = parseFloat(l.innerText), isNaN(a) ? null : a;
    },
    ParseOrZero: (l) => {
      var a;
      return l.getAttribute("data-val") ? a = parseFloat(l.getAttribute("data-val")) : a = parseFloat(l.innerText), isNaN(a) ? 0 : a;
    },
    Total: (l, a) => {
      for (var t = 0, r = 0; r < a.length; r++)
        a[r], t += u.Calc.ParseOrZero(a[r].cells[l]);
      var e = parseFloat(t);
      return (e | 0) === t ? t.toFixed(0) : t.toFixed(2);
    },
    TotalCountForDistribution: (l, a, t) => {
      for (var r = 0, e = a; e < t.cells.length; e++)
        if (t.cells[e].getAttribute("data-aggregate") == "count")
          for (var n = 0; n < l.length; n++)
            r += u.Calc.ParseOrZero(l[n].cells[e]);
      return r;
    },
    WeightedAverage: (l, a, t, r, e, n) => {
      for (var o = null, f = null, d = 0, g = 0, p = n.cells[l].getAttribute("data-col"), i = r; i < n.cells.length; i++) {
        var s = n.cells[i];
        s.getAttribute("data-col") == p && (s.getAttribute("data-aggregate") == "total" && (o = i), s.getAttribute("data-aggregate") == "count" && (f = i));
      }
      if (o != null)
        for (var c = 0; c < t.length; c++)
          n = t[c].cells, f != null ? d += u.Calc.ParseOrZero(n[f]) : d += u.Calc.ParseOrZero(n[o]) * u.Calc.ParseOrZero(n[l]), g += u.Calc.ParseOrZero(n[o]);
      else
        return "";
      return g > 0 ? e == !0 ? (100 * d / g).toFixed(0) : (d / g).toFixed(2) : "";
    }
  },
  ChartData: (l, a, t = null) => {
    const r = l.rows[0];
    var e = (t == null ? void 0 : t.parentNode) ?? l.rows[1];
    if (e.sectionRowIndex == -1)
      return null;
    var n = t != null ? t.getAttribute("data-caption") ?? e.cells[t.cellIndex].innerText : "";
    const o = a.groupCols > 1 ? u.GetGroupRows(t, a.groupCols, l) : l.tBodies[0].rows;
    for (var f = a.counts, d = a.agg, g = a.groupCols, p = [], i = "", s = 0, c = [], h = 0, b = 0, w = [], v = 0; v < o.length; v++) {
      e = o[v], i = (e.cells[0].getAttribute("data-caption") ?? e.cells[0].innerText) + (t != null ? " " + e.cells[t.cellIndex + 1].innerText : ""), p[s] = i, c = [], h = 0;
      for (var C = g; C < r.cells.length; C++)
        if (e.cells[C].style.display != "none") {
          let T = parseFloat(e.cells[C].getAttribute("data-val") ?? e.cells[C].innerText), x = isNaN(T) ? null : T;
          c[h] = x, x !== null && (f[h] > 0 ? (d[h] = d[h] ?? 0 + x, f[h] += 1) : (d[h] = x, f[h] = 1)), h += 1;
        }
      s += 1, w[s] = {
        label: e.cells[0].innerText,
        fill: !1,
        borderColor: u.Colors[b],
        backgroundColor: u.Colors[b],
        data: c,
        lineTension: 0.1,
        hidden: !1
      }, b += 1;
    }
    for (c = [], v = 0; v < d.length; v++)
      c[v] = f[v] > 0 ? (d[v] ?? 0 / f[v]).toFixed(2) : 0;
    return w[0] = {
      label: "Average",
      fill: !1,
      borderColor: u.Colors[b],
      backgroundColor: u.Colors[b],
      data: c,
      lineTension: 0.4
    }, {
      series: p,
      data: w,
      agg: d,
      counts: f,
      title: n,
      max: parseInt(l.getAttribute("data-max"))
    };
  },
  ClearCharts: () => {
    u.Charts = {}, k.instances && Object.keys(k.instances).forEach((l) => {
      k.instances[l].destroy();
    });
  },
  FindSummaryRow: (l, a, t) => {
    for (var r = l.parentNode, e = l.sectionRowIndex, n = null; e >= 0; ) {
      if (n = r.rows[e], n.cells[t].getAttribute("data-group") == a && n.cells[t].getAttribute("data-sum") != null)
        return n;
      e--;
    }
    return null;
  },
  FindFirstGroupRow: (l, a, t) => {
    for (var r = l.parentNode, e = l.sectionRowIndex, n = null; e < r.rows.length; )
      if (e++, n = r.rows[e], n.cells[t].getAttribute("data-group") == a && n.getAttribute("data-sum") == null)
        return n;
    return null;
  },
  GetGroupRows: (l, a, t) => {
    var r = l == null ? void 0 : l.parentNode, e = (l == null ? void 0 : l.cellIndex) ?? -1, n = [], o;
    if (a - e < 3) {
      r = t.rows[r.rowIndex + 1], o = r.cells[e].getAttribute("data-group");
      for (var f = r.parentNode, d = r.sectionRowIndex; r != null && r.cells[e].getAttribute("data-group") == o; )
        (e == 1 || r.cells[1].getAttribute("data-sum") == null) && (n[n.length] = r), d += 1, d < f.rows.length ? r = f.rows[d] : r = null;
      return n;
    }
    r = r ?? t.rows[1], o = e > -1 ? r.cells[e].getAttribute("data-group") : null;
    for (var d = r.rowIndex; r != null && (e == -1 || r.cells[e].getAttribute("data-group") == o); )
      r.cells[e + 1].getAttribute("data-sum") != null && (n[n.length] = r), d += 1, d < t.rows.length ? r = t.rows[d] : r = null;
    return n;
  },
  GroupCol: (l, a, t, r) => {
    for (var e = null, n, o = -1, f, d, g = l.rows.length - 1, p = [], i = [], s = 1; s <= g; s++)
      if (f = l.rows[s], f.getAttribute("data-sum") == null) {
        if (d = f.cells[a], n = d.cellIndex < 1 ? d.innerText : d.parentNode.cells[0].getAttribute("data-group") + "|" + d.innerText, e == null || e !== n || s == g) {
          if (e != null) {
            var c = l.rows[o];
            d = c.cells[a], d.setAttribute("data-group", e), i[i.length] = u.InsertGroupSummaryRow(a, p, t, r, l.querySelector("# tblLabels")), p = [], s++, g += 1;
          }
          s != g && (e = n, o = s);
        }
        f.cells[a].setAttribute("data-group", e), p[p.length] = f, s >= o && (d = f.cells[a], d.setAttribute("data-caption", d.innerText), d.innerHTML = "");
      }
    return i;
  },
  GroupData: (l) => {
    let a = l.querySelectorAll(".GroupCol").length, t = [], r = [], e = [], n = [];
    for (var o = a - 1; o < l.cells.length; o++)
      t[o] = (l == null ? void 0 : l.cells[o].getAttribute("data-aggregate")) ?? "avg", r[o - a] = null, e[o - a] = 0, o >= a && l.cells[o].style.display != "none" && (n[n.length] = l.cells[o].innerText);
    return {
      cols: t,
      agg: r,
      counts: e,
      groupCols: a,
      labels: n
    };
  },
  HideGroup: (l, a, t, r = 0) => {
    var e = t.sectionRowIndex + 1, n = t.parentNode, o = t.style.display != "none";
    t.style.display = "none", e < n.rows.length && (t = n.rows[e], t.cells[a].getAttribute("data-group") == l && (o == !0 && r > 0 ? setTimeout(function() {
      u.HideGroup(l, a, n.rows[e], r);
    }, r) : u.HideGroup(l, a, n.rows[e])));
  },
  InitCharts: (l, a, t, r, e, n, o, f, d = null) => {
    if (r != null || o != null) {
      var g = u.ChartData(l, a, d), p = u.SeriesLegend(f, g.data, g.series, t);
      if (r && u.BuildChart(p, a.labels, t, r, g.max, e), o) {
        for (var i, s = [], c = [], h = 0, b = a.labels, w, v = [], C = [], T, x, m = 1; m < p.length; m++)
          w = p[m], i = w.data, i.length > 1 && i[i.length - 2] > 0 && i[i.length - 1] > 0 && (v[v.length] = i[i.length - 2], C[C.length] = i[i.length - 1], s[s.length] = g.series[m - 1], h += 1);
        if (h > 3)
          T = b[b.length - 2], x = b[b.length - 1];
        else {
          c = [], h = 0, v = [], C = [], s = [];
          for (var m = 1; m < p.length; m++)
            w = p[m], i = w.data, i.length > 2 && i[i.length - 3] > 0 && i[i.length - 2] > 0 && (v[v.length] = i[i.length - 3], C[C.length] = i[i.length - 2], s[s.length] = g.series[m - 1], h += 1);
          h > 3 && (T = b[b.length - 3], x = b[b.length - 2]);
        }
        h > 3 ? (c[0] = {
          label: T,
          order: 2,
          fill: !1,
          borderColor: u.Colors[0],
          backgroundColor: u.Colors[0],
          data: v,
          lineTension: 0.1
        }, c[1] = {
          label: x,
          order: 1,
          fill: !1,
          borderColor: u.Colors[1],
          backgroundColor: u.Colors[1],
          data: C,
          lineTension: 0.1
        }, u.BuildChart(c, s, n, o, g.max, "radar", {
          scale: {
            max: isNaN(g.max) ? 100 : g.max,
            min: 0,
            ticks: { maxTicksLimit: 5 },
            grid: { circular: !0 }
          },
          legend: { display: !0 },
          responsive: !1
        })) : o.style.display = "none";
      }
    }
    if (parseInt(l.getAttribute("data-source")) == 1) {
      var I;
      l.rows[0].appendChild(document.createElement("th"));
      for (var m = 1; m < l.rows.length; m++) {
        I = l.rows[m].cells;
        for (var L = [], P = [], O = 0, D = 0, H = a.groupCols - 1; H < I.length; H++) {
          var N = parseFloat(I[H].getAttribute("data-val"));
          isNaN(N) || (L[L.length] = N, P[P.length] = "", O = Math.min(O, N), D = Math.max(D, N));
        }
        var $ = l.rows[m].insertCell(-1);
        if (L.length > 2) {
          var S = document.createElement("canvas");
          S.id = t.replace("divGpaChart", "tdSparkline" + m), S.width = "100", S.height = "32", S.style.backgroundColor = "#ececec", $.appendChild(S), u.BuildChart(
            [{
              borderColor: "black",
              borderWidth: 0.5,
              backgroundColor: "#cfebf8",
              data: L,
              lineTension: 0.3,
              pointRadius: 0,
              fill: "origin"
            }],
            P,
            S.id,
            S,
            0,
            "line",
            {
              responsive: !1,
              maintainAspectRatio: !1,
              plugins: {
                legend: {
                  display: !1,
                  labels: { display: !1 }
                }
              },
              scales: {
                x: { grid: { display: !1 } },
                y: {
                  display: !1,
                  max: D * 1.5,
                  min: O
                }
              }
            }
          ), S.height = "16";
        }
      }
    }
    return (g == null ? void 0 : g.title) ?? "";
  },
  InsertGroupSummaryRow(l, a, t, r, e) {
    var n = a[0], o = n.parentNode, f = n.cells.length, d = o.insertRow(n.sectionRowIndex), g = null, p, i;
    d.className = "Alt";
    for (var s = 0; s < f; s++)
      d.insertCell(s);
    for (s = 1; s < t; s++)
      d.cells[s].style.borderLeftColor = "transparent";
    for (s = t; s < f; s++) {
      switch (n.cells[s].style.display == "none" && (d.cells[s].style.display = "none"), r[s]) {
        case "count":
        case "total":
          p = u.Calc.Total(s, a), i = !1;
          break;
        case "weighted":
        case "weightedPercent":
          p = u.Calc.WeightedAverage(s, d, a, t, r[s] != "weighted", o.rows[0]), i = !0;
          break;
        case "distributionPercent":
          g == null && (g = u.Calc.TotalCountForDistribution(a, t, o.rows[0])), p = u.Calc.Distribution(s, a, g), i = !0;
          break;
        default:
          p = u.Calc.Average(s, a), i = !1;
      }
      i && e ? u.SetLabel(e, d.cells[s], p) : d.cells[s].innerHTML = p;
    }
    var c = d.cells[l], h = n.cells[l].getAttribute("data-caption");
    return c.setAttribute("data-caption", h), c.innerHTML = ">  " + h + " (" + a.length + " rows) ", c.setAttribute("data-group", n.cells[l].getAttribute("data-group")), c.setAttribute("data-groupRow", a.length), c.setAttribute("data-sum", "1"), d.setAttribute("data-sum", "1"), c;
  },
  LegendItem: (l, a, t, r, e) => {
    var n = document.createElement("div");
    r != null && (n.style.backgroundColor = r);
    var o = document.createElement("input"), f = document.createElement("label");
    return o.setAttribute("type", "checkbox"), o.value = l, o.checked = t, e != null && o.addEventListener("click", () => e(o), !1), f.appendChild(o), f.appendChild(document.createTextNode(a)), n.appendChild(f), n;
  },
  SeriesLegend: (l, a, t, r) => {
    l.innerHTML = "", l.appendChild(u.LegendItem(0, "Average", !0, a[0].backgroundColor, function(o) {
      u.ToggleSeries(o.value, o.checked, r);
    }));
    for (var e = 0; e < t.length; e++) {
      var n = u.LegendItem(e + 1, t[e], !1, a[e + 1].backgroundColor, function(o) {
        u.ToggleSeries(o.value, o.checked, r);
      });
      a[e + 1].hidden = !n.ariaChecked, l.appendChild(n);
    }
    return a;
  },
  SetLabel: (l, a, t) => {
    let r = parseFloat(t);
    if (!isNaN(r))
      for (var e = l.rows.length; e > 0; e--) {
        let n = l.rows[e - 1].cells;
        if (r > parseFloat(n[1].innerText)) {
          n[0].childNodes.length > 0 && n[0].childNodes[0].innerText == "[Value]" || (t = n[0].innerText), a.bgColor = n[0].bgColor, a.setAttribute("data-val", r);
          break;
        }
      }
    a.innerHTML = t;
  },
  ShowGroup(l, a, t, r, e = 0) {
    var n = t.sectionRowIndex + 1, o = t.parentNode;
    t.cells[a].getAttribute("data-group") == l ? (r != null ? t.cells[1].getAttribute("data-group") != r && (r = null, t.style.display = "") : t.style.display = "", a == 0 && t.cells[1].getAttribute("data-sum") && (r = t.cells[1].getAttribute("data-group")), n < o.rows.length ? t = o.rows[n] : t = null) : t = null, t != null && (t.style.display == "none" && r == null && e > 0 ? setTimeout(function() {
      u.ShowGroup(l, a, o.rows[n], r, e);
    }, e) : u.ShowGroup(l, a, o.rows[n], r));
  },
  ToggleGroup: (l, a = !0, t = 0) => {
    var r = l.cellIndex, e = l.parentNode, n = e.parentNode, o = e.sectionRowIndex;
    if (o == -1)
      return !1;
    var f = l.getAttribute("data-group"), d;
    a ? (d = u.FindSummaryRow(e, f, r), o + 1 < n.rows.length && (u.HideGroup(f, r, n.rows[o], t), d.style.display = "")) : (d = e, e = u.FindFirstGroupRow(d, f, r), e != null && u.ShowGroup(f, r, d, null, t));
  },
  ToggleSeries: (l, a, t) => {
    const r = u.Charts[t];
    r.data.datasets[parseInt(l)].hidden = !a, r.update();
  }
}, Ne = ({ studentId: l, studentName: a }) => {
  const [t, r] = G(!1), [e, n] = G(), o = Y(null), { isPending: f, error: d, data: g } = new B.DateRanges({}).ToQuery(), { isPending: p, error: i, data: s, refetch: c } = new U.AssessmentDash({ studentId: Number(l), from: e == null ? void 0 : e.From, to: e == null ? void 0 : e.To }).ToQuery();
  J(() => {
    e != null && e.From && (e != null && e.To) && c();
  }, [e]);
  const h = async () => {
    console.log("init dash", o.current), o.current && ee(o.current.contentDocument);
  };
  return p && !t ? /* @__PURE__ */ A(R, { severity: "info", children: [
    "Loading ",
    a ? `${a}'s` : "",
    " Dashboard..."
  ] }) : i ? (console.log(i), /* @__PURE__ */ A(R, { severity: "error", children: [
    "Error loading ",
    a ? `${a}'s` : "",
    " Dashboard."
  ] })) : t || s ? t ? /* @__PURE__ */ A(V, { fullScreen: !0, showFullScreenControls: !0, title: "Assessment Dashboard", open: !0, onClose: () => r(!1), maxWidth: !1, children: [
    g && /* @__PURE__ */ y(te, { data: g, onChange: (w) => {
      n(w);
    } }),
    f && /* @__PURE__ */ y(R, { severity: "info", children: "Loading Date Ranges data..." }),
    d && /* @__PURE__ */ y(R, { severity: "error", children: "Error loading Date Ranges data." }),
    p && /* @__PURE__ */ A(R, { severity: "info", children: [
      "Loading ",
      a ? `${a}'s` : "",
      " Dashboard..."
    ] }),
    s && /* @__PURE__ */ y("iframe", { srcDoc: `<style>
                a {
                    color: inherit;
                    text-decoration: none; 
                    pointer-events: none;
                }
                body {
                    font-family: "Open Sans","Roboto","Helvetica Neue", Helvetica, Arial, sans-serif;
                }
                .Caption {
                    font-size: .8rem;
                    color: #8a8a8a;
                    white-space: nowrap;
                } 
                div.Header, h2 { 
                    margin: .55em 0px;
                    color: var(--neutralPrimaryAlt, #3b3a39);
                    font-size: 1.2rem;
                }
                label {
                    margin-right: 5px;
                }
                table.AnalysisReportData div.ValueBadge {
                    margin: auto;
                    border-radius: 6px;
                    overflow: hidden;
                    text-align: center;
                    vertical-align: middle;
                    line-height: 20px;
                    padding: 2px;
                }
                table.Grid tr td, table.Grid tr th {
                    white-space: nowrap;
                }            
                table.Report {
                    font-size: .8rem;
                    border-collapse: collapse;
                    border: none;
                }
                table.Report th {
                    background-color: var(--mui-palette-primary-main, #006CBE);
                    color: #fff;
                    font-weight: normal;
                    border: none;
                    padding: 6px; text-align: left;
                }
                table.Report tr:not(.transparent) td {
                    border-bottom: 1px solid var(--mui-palette-TableCell-border, #e0e0e0);
                    padding: 6px;
                    text-align: left;
                }
                table.Report tr:nth-child(odd of :not([style*="display: none"])):not(.withAttendance) td:not(.agNotMarked):not(.agPresent):not(.agNoday):not(.agWeekday):not(.agUnapproved):not(.agLate):not(.agLeft) {
                    background-color: var(--neutralLight, #edebe9);
                }
                table.Report tr:nth-child(even of :not([style*="display: none"])):not(.withAttendance) td:not(.agNotMarked):not(.agPresent):not(.agNoday):not(.agWeekday):not(.agUnapproved):not(.agLate):not(.agLeft) {
                    background-color: var(--neutralLight, #f3f2f1);
                }
    
                </style>` + s, width: "100%", height: "100%", onLoad: h, ref: o })
  ] }) : /* @__PURE__ */ A(R, { severity: "info", icon: /* @__PURE__ */ y(z, { iconType: Q.Profile }), children: [
    /* @__PURE__ */ y(K, { children: "Dashboard" }),
    /* @__PURE__ */ A(M, { variant: "text", color: "info", onClick: () => r(!0), children: [
      "Click here to view ",
      a ? `${a}'s` : "your",
      " Dashboard"
    ] })
  ] }) : null;
}, te = ({ data: l, onChange: a }) => {
  const [t, r] = G({ Id: 0, From: void 0, To: void 0 }), e = (/* @__PURE__ */ new Date()).getFullYear(), [n, o] = G(), [f, d] = G(), g = () => {
    n && f && n < f && (r({ Id: -2, From: n, To: f }), a({ From: F(n).toISOString(), To: F(f).toISOString() }));
  }, p = (i) => {
    let s = i >= 0 ? l.find((c) => c.Id == i) ?? l.find((c) => c.Id == e || c.Id == e - 1) ?? l[0] : null;
    (s == null ? void 0 : s.Id) != t.Id && r({ Id: (s == null ? void 0 : s.Id) ?? i, From: (s == null ? void 0 : s.From) ?? t.From, To: (s == null ? void 0 : s.To) ?? t.To }), i > 0 ? a({ Id: i, From: F(s == null ? void 0 : s.From).toISOString(), To: F(s == null ? void 0 : s.To).toISOString() }) : i > -2 && (o(t.From), d(t.To));
  };
  return l && t.Id == 0 && p(t.Id), l ? /* @__PURE__ */ A(X, { sx: { display: "flex", justifyContent: "space-between", alignItems: "center", gap: 2, flexWrap: "wrap", p: 2, width: "fit-content" }, children: [
    /* @__PURE__ */ A(E, { sx: { minWidth: 150, display: "inline" }, children: [
      /* @__PURE__ */ y(_, { id: "dashRange-label", children: "Date Range" }),
      /* @__PURE__ */ A(
        j,
        {
          sx: { marginRight: "10px", maxWidth: "60%" },
          labelId: "dashRange-label",
          id: "dashRange",
          label: "Date Range",
          value: t.Id,
          onChange: (i) => p(Number(i.target.value)),
          children: [
            l.map((i) => /* @__PURE__ */ y(W, { value: i.Id, children: i.Label ?? `${i.From} - ${i.To}` }, i.Id)),
            t.Id < 0 && /* @__PURE__ */ y(W, { value: t.Id, disabled: !0, children: "Custom" })
          ]
        }
      ),
      /* @__PURE__ */ y(M, { variant: "contained", onClick: () => {
        t.Id != -1 && p(-1);
      }, children: "Custom Range" })
    ] }),
    t.Id == -1 && /* @__PURE__ */ A(E, { sx: { display: "inline", verticalAlign: "text-bottom" }, children: [
      /* @__PURE__ */ y(q, { sx: { marginRight: "10px", maxWidth: "35%" }, label: "From", value: F(n ?? t.From ?? F()), onChange: (i) => (i == null ? void 0 : i.isValid()) && o(i.toDate()) }),
      /* @__PURE__ */ y(q, { sx: { marginRight: "10px", maxWidth: "35%" }, label: "To", value: F(f ?? t.To ?? F().add(7, "day")), onChange: (i) => (i == null ? void 0 : i.isValid()) && d(i.toDate()) }),
      /* @__PURE__ */ y(M, { variant: "contained", sx: { marginTop: 1, maxWidth: "15%" }, onClick: () => g(), children: "Apply" }),
      n && f && n >= f && /* @__PURE__ */ y(R, { severity: "error", children: "Please select a valid Date Range." })
    ] })
  ] }) : null;
};
export {
  Ne as AssessmentDashboard
};
//# sourceMappingURL=AssessmentDashboard.js.map
